<template>
  <div class="manager-userList-view">
    <section class="module">
      <div class="m-body filter">
        <el-input v-model="query.identity" placeholder="请输入手机号码或昵称" class="filter-name" :maxlength="15"></el-input>
        <div class="inline-block ml20">
          <span>注册日期</span>
          <el-date-picker v-model="query.regBegin" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
          <span>至</span>
          <el-date-picker v-model="query.regEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
        </div>
        <el-select v-model="query.class" clearable filterable class="filter-class ml20" placeholder="请选择班级">
          <el-option v-for="item in classes" :label="item" :value="item" :key="item"></el-option>
        </el-select>
        <div class="mt10"></div>
        <el-select v-model="query.purStaus" clearable placeholder="购买状态" class="filter-purStaus">
          <el-option value="2" label="生效中"></el-option>
          <el-option value="1" label="未购买"></el-option>
          <el-option value="3" label="已过期"></el-option>
        </el-select>
        <div class="inline-block ml20">
          <span>有效期限</span>
          <el-date-picker v-model="query.purBegin" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
          <span>至</span>
          <el-date-picker v-model="query.purEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
        </div>
        <el-select v-model="query.type" clearable filterable class="filter-class ml20" placeholder="用户类型">
          <el-option v-for="item in userTypes" :label="item.text" :value="item.value" :key="'userType_' + item.value"></el-option>
        </el-select>
        <div class="inline-block ml20">
          <el-button type="primary" @click="searchClick" class="w182">搜索</el-button>
        </div>
      </div>
    </section>
    <section class="module mt10">
      <div class="m-body">
        <el-table :data="list" stripe empty-text="暂无数据">
          <!-- <el-table-column align="center" type="selection" width="45"></el-table-column> -->
          <el-table-column align="center" label="手机号码" prop="mobile"></el-table-column>
          <el-table-column align="center" label="昵称" prop="nick"></el-table-column>
          <el-table-column align="center" label="用户类型" prop="type" :formatter="userTypeFormatter" width="100"></el-table-column>
          <el-table-column align="center" label="备注信息" prop="remark" width="120" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.remark || '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="注册时间" prop="regTime">
            <template slot-scope="scope">
              <span>{{scope.row.regTime | dateFormat}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="有效期限" prop="purExpiry">
            <template slot-scope="scope">
              <span>{{scope.row.purExpiry | dateFormat('yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="所在班级" prop="className"></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openDialog(scope.row)">设置</el-button>
              <el-button type="warning" size="mini" @click="resetPwd(scope.row)">重置密码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-show="!loading && total > 0" :current-page="query.pageIndex" :page-size="query.pageSize" :total="total" :page-sizes="[10, 20]"
          layout="total, sizes, ->, prev, pager, next, jumper" @size-change="pageSizeChange" @current-change="pageChange" class="mt10">
        </el-pagination>
      </div>
    </section>
    <user-dialog v-if="dialog.show" :info="dialog.info" @closed="dialogClosed"></user-dialog>
  </div>
</template>

<script>
import userDialog from './userDialog'

export default {
  name: 'userList',
  components: { userDialog },
  data () {
    return {
      list: [],
      total: 0,
      classes: [],
      query: {
        identity: '',
        regBegin: '',
        regEnd: '',
        class: '',
        purStaus: '',
        purBegin: '',
        purEnd: '',
        pageIndex: 1,
        pageSize: 10,
        type: ''
      },
      dialog: {
        info: {},
        show: false
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    userTypes () {
      return this.$store.getters.userTypes
    }
  },
  created () {
    this.$store.dispatch('setNavigation', [{ name: '管理中心' }, { name: '用户管理' }])
    this.getClasses()
    this.getData()
  },
  methods: {
    getData () {
      this.$store.dispatch('setLoading')
      // 获取数据
      this.$http.post('admin/finduser', this.query)
        .then(response => {
          this.$nextTick(() => {
            this.list = response.users
            this.total = response.total
          })
        })
        .catch(() => {
          this.list = []
          this.total = 0
          this.$message.error('获取数据失败，请重试')
        })
        .then(() => {
          this.$store.dispatch('setLoading', false)
        })
    },
    searchClick () {
      if (this.query.pageIndex === 1) {
        this.getData()
      } else {
        this.query.pageIndex = 1
      }
    },
    getClasses () {
      this.$store.dispatch('getClasses')
        .then(response => {
          this.$nextTick(() => {
            this.classes = response
          })
        })
    },
    pageSizeChange (newSize) {
      this.query.pageSize = newSize
      if (this.query.pageIndex === 1) {
        this.getData()
      } else {
        this.query.pageIndex = 1
      }
    },
    pageChange (newPage) {
      this.query.pageIndex = newPage
      this.getData()
    },
    openDialog (row) {
      this.dialog.info = row
      this.dialog.show = true
    },
    dialogClosed (refresh) {
      this.dialog.show = false
      if (refresh) {
        this.getData()
      }
    },
    resetPwd (row) {
      this.$confirm(`请确认是否重置用户（${row.nick}）的密码？`, '重置密码')
        .then(() => {
          // 调用重置密码接口
          this.$http.post('admin/resetpwd', {uid: row.uid})
            .then(response => {
              this.$message.success('密码已重置为手机号码后6位')
            })
            .catch(() => {
              this.$message.error('密码重置失败')
            })
        })
        .catch(() => { })
    },
    userTypeFormatter (row, column, cellValue, index) {
      let result = '未知'
      this.userTypes.forEach(item => {
        if (item.value === cellValue) {
          result = item.text
          return false
        }
      })
      return result
    }
  }
}
</script>

<style lang="scss">
.manager-userList-view {

  .filter-name, .filter-purStaus {
    width: 180px;
  }
  .filter-class {
    width: 182px;
  }
  .el-date-editor {
    width: 150px;
  }
  .w182 {
    width: 182px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/manager/userList.vue